module.exports = __webpack_public_path__ + "static/media/8.214a0fc9.jpg";